import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'million'
})
export class MillionPipe implements PipeTransform {

  transform(value: number, digits?: string): string {
    if (value === null || value === undefined || isNaN(value)) {
      return '';
    }

    let num = Math.floor(value); // Ensure the value is an integer
    let numStr = num.toString();
    let result = '';
    let length = numStr.length;

    if (length <= 3) {
      return numStr;
    }

    // Handle the last three digits separately (thousands)
    result = numStr.substring(length - 3);

    // Process the rest of the digits in groups of two (lakhs, crores)
    let remainingDigits = length - 3;
    while (remainingDigits > 0) {
      result = numStr.substring(remainingDigits - 2, remainingDigits) + ',' + result;
      remainingDigits -= 2;
    }

    return result;
  }

}
